import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useRunEmailExecTemplateMutation({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: (job: Api.IEmailExecBriefSystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (templateId: string) => {
			return userSession.webServiceHelper.callAsync<Api.IEmailExecBriefSystemJob>(
				`emailExecAssistant/templates/${templateId}/run`,
				'POST',
				{}
			);
		},
		onError,
		onSuccess,
		onSettled,
	});
}
